// API Configuration - determines endpoints based on environment
// TODO: merge this file and config.ts

const isDevelopment = import.meta.env.MODE === 'development';

function requireEnv(name: string): string {
  const val = import.meta.env[name];
  if (!val) {
    throw new Error(
      `Missing required env var ${name}. ` +
        'Ensure it is set when running vite build for production.',
    );
  }
  return val;
}

const BASE_URL = isDevelopment
  ? 'http://localhost:4000'
  : requireEnv('VITE_API_URL');

// GraphQL API
export const GRAPHQL_URL = isDevelopment
  ? 'http://localhost:4000/graphql'
  : (import.meta.env.VITE_GRAPHQL_URL ?? `${BASE_URL}/graphql`);

// WebSocket
export const WEBSOCKET_URL = isDevelopment
  ? 'ws://localhost:4000/ws'
  : requireEnv('VITE_WEBSOCKET_URL');

// Story Analyzer Flask API
export const STORY_ANALYZER_URL = isDevelopment
  ? ''
  : (import.meta.env.VITE_STORY_ANALYZER_URL ?? '');

// Health check endpoints
export const API_HEALTH = `${BASE_URL}/health`;
export const ANALYZER_HEALTH = `${STORY_ANALYZER_URL}/health`;

// Log configuration in development
if (isDevelopment) {
  console.log('🔧 API Configuration (Development Mode):');
  console.log('  GraphQL:', GRAPHQL_URL);
  console.log('  WebSocket:', WEBSOCKET_URL);
  console.log('  Story Analyzer:', STORY_ANALYZER_URL);
}

// Export configuration object
export const API_CONFIG = {
  graphql: GRAPHQL_URL,
  websocket: WEBSOCKET_URL,
  storyAnalyzer: STORY_ANALYZER_URL,
  health: API_HEALTH,
  analyzerHealth: ANALYZER_HEALTH,
  isDevelopment,
};
